import { Link } from 'react-router-dom'
import type { ChromeLink as ChromeLinkType } from '../api/site-chrome'

export function ChromeLink({
  item,
  className,
  onClick,
}: {
  item: ChromeLinkType
  className?: string
  onClick?: () => void
}) {
  const external =
    item.external ?? (/^https?:\/\//i.test(item.href) || item.href.startsWith('mailto:'))
  if (external) {
    return (
      <a href={item.href} className={className} target="_blank" rel="noreferrer" onClick={onClick}>
        {item.label}
      </a>
    )
  }
  return (
    <Link to={item.href} className={className} onClick={onClick}>
      {item.label}
    </Link>
  )
}
